import { render, staticRenderFns } from "./UserVehiclesTable.vue?vue&type=template&id=35ef8245"
import script from "./UserVehiclesTable.vue?vue&type=script&lang=js"
export * from "./UserVehiclesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports